import { Heading } from '@lmig/lmds-react-typography';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';
import './LoadingScreen.scss';

export default function LoadingScreen() {
  return (
    <div id="activity-loading-screen">
      <Heading type="h4">Loading...</Heading>
      <CircularProgressSpinner size="64" aria-label="Getting activity..." className="centered-loading-spinner" />
    </div>
  );
}
